import { styled } from '@mui/material';
import { Outlet } from 'react-router';

import { Container } from '@app-velocity/ui';

const StyledWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  flex: 1,
  gap: theme.spacing(8),
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100vh',
}));

export const TeamInvitationWrapper = () => {
  return (
    <StyledWrapper>
      <Container variant="narrow">
        <Outlet />
      </Container>
    </StyledWrapper>
  );
};
